"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
export default function Portfolio() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: trustRef,
    isVisible: trustVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: scrollRef,
    isVisible: scrollVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const trustSignals = [{
    icon: "\u23F1",
    label: "Prompt Estimates"
  }, {
    icon: "\u{1F512}",
    label: "Licensed & Insured"
  }, {
    icon: "\u2615",
    label: "Consultation Ready"
  }];
  return <section data-section-id="246" id="our-portfolio-of-excellence" className="dark bg-background text-foreground relative overflow-hidden min-h-[80vh] flex flex-col justify-center px-6 sm:px-10 lg:px-16 pt-32 pb-16 sm:pt-40 sm:pb-20">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "radial-gradient(var(--foreground) 1px, transparent 1px), radial-gradient(var(--foreground) 1px, transparent 1px)",
      backgroundSize: "3px 3px, 7px 7px",
      backgroundPosition: "0 0, 1px 1px"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-20 -right-10 sm:-right-20 select-none font-serif font-light text-[20rem] sm:text-[28rem] lg:text-[36rem] leading-none text-foreground opacity-[0.08]">
        +
      </div>

      <div className="relative max-w-6xl mx-auto w-full flex flex-col items-center text-center">
        {}
        <div ref={eyebrowRef} className={`flex items-center gap-2.5 font-mono text-xs sm:text-sm tracking-[0.25em] uppercase text-muted-foreground transition-all duration-700 ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <span className="inline-block w-1.5 h-1.5 rounded-lg bg-primary" />
          <span>Our Work</span>
        </div>

        {}
        <h1 ref={headlineRef} className={`mt-8 sm:mt-10 font-serif font-normal text-5xl sm:text-7xl md:text-8xl lg:text-9xl leading-[1.02] text-foreground transition-all duration-1000 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        letterSpacing: "-0.04em"
      }}>
          Portfolio of{" "}
          <span className="relative inline-block italic">
            excellence
            <svg aria-hidden="true" className="absolute left-0 -bottom-2 sm:-bottom-3 w-full" viewBox="0 0 300 12" preserveAspectRatio="none" fill="none">
              <path d="M2 8 C 60 2, 140 11, 220 5 S 290 8, 298 4" stroke="var(--chart-3)" strokeWidth="3" strokeLinecap="round" fill="none" />
            </svg>
          </span>
          .
        </h1>

        {}
        <p ref={paragraphRef} className={`mt-10 sm:mt-12 font-default text-lg sm:text-xl text-muted-foreground max-w-[580px] mx-auto transition-all duration-1000 delay-100 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        lineHeight: 1.65
      }}>
          At Moscariello Construction Co, Inc, we transform visions into structural reality. From custom residential builds to comprehensive property management, our portfolio reflects a commitment to precision, durability, and the highest standards of craftsmanship in Collegeville and beyond.
        </p>

        {}
        <div ref={trustRef} className={`mt-14 sm:mt-16 w-full max-w-2xl transition-all duration-1000 delay-200 ${trustVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Separator className="bg-border/60" />
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 py-5 sm:py-6 font-mono text-xs sm:text-sm text-muted-foreground">
            {trustSignals.map((signal, i) => <div key={i} data-index={i} className="flex items-center gap-2">
                <span className="text-primary text-base" aria-hidden="true">
                  {signal.icon}
                </span>
                <span className="tracking-wide">{signal.label}</span>
                {i < trustSignals.length - 1 && <span className="hidden sm:inline ml-6 text-border" aria-hidden="true">
                    |
                  </span>}
              </div>)}
          </div>
          <Separator className="bg-border/60" />
        </div>

        {}
        <div ref={scrollRef} className={`mt-16 sm:mt-20 flex flex-col items-center gap-4 transition-all duration-1000 delay-300 ${scrollVisible ? "opacity-100" : "opacity-0"}`}>
          <div className="w-px h-12 sm:h-16 bg-gradient-to-b from-transparent via-border to-foreground/40 scroll-line" />
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground" style={{
          writingMode: "vertical-rl",
          transform: "rotate(180deg)"
        }}>
            Explore Projects &rarr;
          </span>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-border/60" />

      <style>{`
        @keyframes scrollBob {
          0%, 100% { transform: translateY(0); opacity: 0.6; }
          50% { transform: translateY(6px); opacity: 1; }
        }
        .scroll-line {
          animation: scrollBob 2.4s ease-in-out infinite;
          transform-origin: top center;
        }
      `}</style>
    </section>;
}